import React from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../utils/axiosInstance';

const Logout = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await axios.post('/auth/logout', {}, { withCredentials: true });
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
      navigate('/login');
    }
  };

  return (
    <div>
      <h2>You are logged out</h2>
      <button onClick={handleLogout}>Go to Login</button>
    </div>
  );
};

export default Logout;
